import { Box, ServiceLogo, Typography } from '@wishket/design-system';
import { twMerge } from 'tailwind-merge';

import { EXTERNAL_LINKS } from '../Footer.constants';

import { Link } from '@/shared/Components';

interface ServiceSetProps {
  needBorderTop?: boolean;
}

const ServiceSet = ({ needBorderTop }: ServiceSetProps) => {
  return (
    <Box
      className={twMerge(
        'flex w-full flex-col justify-start gap-4 border-b border-w-gray-200 py-8 grid-in-service desktop:flex-row desktop:items-center desktop:gap-8 desktop:py-4',
        needBorderTop && 'border-w-gray-200 desktop:border-t'
      )}
      data-testid="footer-service-set"
    >
      <Typography variant="body1" className="font-medium text-w-gray-600">
        서비스 전체보기
      </Typography>
      <Box className="flex gap-4">
        <Link
          href={EXTERNAL_LINKS.WISHKET}
          className="flex items-center gap-1.5 hover:underline"
          data-testid="wishket-link"
        >
          <ServiceLogo name="wishket_symbol" />
          <Typography variant="body1" className="text-w-gray-600">
            위시켓
          </Typography>
        </Link>
        <Link
          href={EXTERNAL_LINKS.YOZMIT}
          className="flex items-center gap-1.5 hover:underline"
          data-testid="yozmit-link"
        >
          <ServiceLogo name="yozmIT_symbol" />
          <Typography variant="body1" className="text-w-gray-600">
            요즘IT
          </Typography>
        </Link>
      </Box>
    </Box>
  );
};

export default ServiceSet;
